// node_modules
import React from "react";
import { Button } from "primereact/button";
import { useNavigate } from "react-router";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

// mock data
import { tableData } from "../../mockData";

// styles
import * as styles from "./Table.module.css";

export const Table = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.wrapper}>
      <div style={{ height: "90%", overflowY: "scroll" }}>
        <DataTable
          value={tableData}
          tableStyle={{ minWidth: "50rem" }}
          rowClassName={(row) => {
            return row.highlight ? "highlighted_row" : null;
          }}
        >
          <Column field="borrower" header="Должник"></Column>
          <Column field="creditor" header="Кредитор"></Column>
          <Column field="sum" header="Сумма (₸)"></Column>
        </DataTable>
      </div>
      <div
        style={{
          width: "70%",
          display: "flex",
          justifyContent: "space-between",
          fontWeight: "800",
        }}
      >
        <Button className={styles.paginationBtn} disabled>
          {"<"}
        </Button>
        <Button
          className={styles.paginationBtn}
          onClick={() => navigate("/graph")}
        >
          {">"}
        </Button>
      </div>
    </div>
  );
};
